import { Box, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { VisuallyHiddenInput } from ".";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import { Img } from "components/Img";
import { useState } from "react";
import { Messages } from "helpers/constants";
import { useAppDispatch } from "hooks/useAppDispatch";
import { uploadFile } from "reduxStore/files/thunks";

type OrganizationUploadImageProps = {
  // uploading: boolean;
  // errorImage: string;
  onUploadedFile: (event: string) => void;
  img: string;
};

export const OrganizationUploadImage = ({
  // uploading,
  // errorImage,
  // onUploadFile,
  img,
  onUploadedFile,
}: OrganizationUploadImageProps) => {
  const [uploading, setUploading] = useState(false);
  const [errorImage, setErrorImage] = useState("");

  const dispatch = useAppDispatch();

  const onUploadFile = async (event: React.BaseSyntheticEvent) => {
    const file = event.target.files[0];
    if (!file) return;
    if (file.type !== "image/png" && file.type !== "image/jpeg") {
      setErrorImage(Messages.errorInvalidImageType);
      return;
    }
    if (file.size > 1024 * 1024 * 10) {
      setErrorImage(Messages.errorImageSize);
      return;
    }
    if (errorImage !== "") setErrorImage("");
    setUploading(true);
    const result = await dispatch(uploadFile(event.target.files[0]));
    if (result.meta.requestStatus === "rejected") {
      setErrorImage(Messages.errorImageUpload);
    } else {
      onUploadedFile(result?.payload?.filePath);
    }
    setUploading(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
      py={2}
    >
      <Box sx={{ position: "relative" }}>
        <Button
          disabled={uploading}
          component="label"
          role={undefined}
          variant="outlined"
          tabIndex={-1}
          startIcon={<CloudUploadIcon />}
        >
          Upload files
          <VisuallyHiddenInput type="file" onChange={onUploadFile} />
        </Button>
        {errorImage !== "" && (
          <Box mt={1} sx={{ color: "red" }}>
            {errorImage}
          </Box>
        )}

        {uploading && (
          <CircularProgress
            size={30}
            sx={{
              color: green[500],
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
          />
        )}
      </Box>
      <Box sx={{ position: "relative" }}>
        <Img src={img} width={80} height={80} />
        {uploading && (
          <CircularProgress
            size={30}
            sx={{
              color: green[500],
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
          />
        )}
      </Box>
    </Box>
  );
};
